import {
	END_USER_SERIAL_NUMBERS_FETCH_REQUEST,
	END_USER_SERIAL_NUMBERS_FETCH_FAILURE,
	END_USER_SERIAL_NUMBERS_FETCH_SUCCESS,
	END_USER_SERIAL_NUMBER_CREATE_REQUEST,
	END_USER_SERIAL_NUMBER_CREATE_FAILURE,
	END_USER_SERIAL_NUMBER_CREATE_SUCCESS,
	END_USER_SERIAL_NUMBER_DELETE_REQUEST,
	END_USER_SERIAL_NUMBER_DELETE_FAILURE,
	END_USER_SERIAL_NUMBER_DELETE_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	isUpdating: false,
	isCreating: false,
	isDeleting: false,
	message: {
		type: '',
		text: '',
	},
	selected: false,
};

export default function reducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case END_USER_SERIAL_NUMBERS_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
			};

		case END_USER_SERIAL_NUMBERS_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case END_USER_SERIAL_NUMBERS_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: '',
					text: '',
				},
			};

		case END_USER_SERIAL_NUMBER_CREATE_REQUEST:
			return {
				...state,
				isCreating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case END_USER_SERIAL_NUMBER_CREATE_FAILURE:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case END_USER_SERIAL_NUMBER_CREATE_SUCCESS:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case END_USER_SERIAL_NUMBER_DELETE_REQUEST:
			return {
				...state,
				isDeleting: true,
				message: {
					type: '',
					text: '',
				},
			};

		case END_USER_SERIAL_NUMBER_DELETE_FAILURE:
			return {
				...state,
				isDeleting: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case END_USER_SERIAL_NUMBER_DELETE_SUCCESS:
			return {
				...state,
				isDeleting: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/endUserSerialNumbers.js